import type { EventBusKey } from '@vueuse/core'

export const taskKey: EventBusKey<string> = Symbol('task-events')
export const photoKey: EventBusKey<string> = Symbol('photo-events')
